module.exports = __webpack_public_path__ + "static/media/free-scrap-removal-beenleigh.39d14483.png";